import { Link } from 'react-router';
import imgLogotexticon1 from '../../assets/logo-cherry-color.webp';
import { PrimaryButton } from '../components/PrimaryButton';

export default function HomePage() {
  return (
    <div className="size-full bg-white flex flex-col items-center justify-center">
      <div className="text-center max-w-2xl px-4">
        <div className="mb-8 flex justify-center">
          <img
            alt="Cherry Picked"
            className="h-[73px] w-auto object-contain"
            src={imgLogotexticon1}
          />
        </div>

        <h1 className="font-['Playfair_Display',sans-serif] font-extrabold leading-[64px] text-[#8e2a2f] text-[48px] tracking-[-0.0944px] mb-4">
          Welcome to Our Platform
        </h1>

        <p className="font-['DM_Sans',sans-serif] font-normal leading-[28px] text-[#908e8e] text-[18px] tracking-[-0.1px] mb-12" style={{ fontVariationSettings: "'opsz' 14" }}>
          Join us today and experience something amazing
        </p>

        {/* Single auth CTA — the sign-in page has a "Create account"
            link for new users, so we don't need a separate Sign Up
            button here. Gift cards are guest-friendly (no account
            needed), so they get their own CTA alongside. */}
        <div className="flex gap-4 justify-center flex-wrap">
          <Link to="/signin/customer">
            <PrimaryButton>Sign In</PrimaryButton>
          </Link>
          <Link
            to="/gift-card"
            className="inline-flex items-center justify-center px-6 h-[50px] rounded-md border border-[#8e2a2f] text-[#8e2a2f] hover:bg-[#fbeaea] font-['DM_Sans',sans-serif] font-bold text-[14px] transition-colors"
          >
            Buy a Gift Card
          </Link>
        </div>
      </div>
    </div>
  );
}
